<template>
  <div id="app">
    <div v-show="this.$store.state.DLINE_ENVIRONMENT" id="devenvironment_warning" style="position:fixed;z-index:10000;top:0;width:100px;margin-left:-50px;left:50%;background-color:#ffb734;text-align:center;padding:10px;border-radius:0 0 4px 4px;opacity:.5;font-weight:bold;pointer-events:none;">测试环境</div>
    <!-- <keep-alive :include="['GoodsList']">
        <router-view v-if="$route.meta.keepAlive"></router-view>
     </keep-alive>
     <router-view v-if="!$route.meta.keepAlive"></router-view> -->
     <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      
    };
  },
  watch: {
    '$route': {
      handler(to, from){
        //console.log(to);
        //console.log(from);
      },
      immediate: true,//首次进入页面即执行
    },
  },
  mounted() {

  },
  created(){
    const _this = this;
    window['jsGetToken'] = (token) => {
      _this.getToken(token)
    }
    //设备
    //window._vue = this;
    window['getEquipmentResult'] = (equipment) =>{
      _this.getequipment(equipment)
    }
  },
  methods: {
    getToken(token){
      const _this = this;
      _this.$store.commit('updatetoken', {
        label: 'gettoken',
        data: token
      });

      _this.getUserInfo(token ? token : _this.$route.query.token, '', '');
    },
    getequipment(equipment){
      const _this = this;
      //_this.ingetEquipmentResult = '调用方法成功'
      let equipmentData
      if(equipment){
        equipmentData = true
      } else {
        equipmentData = false
      }
      _this.$store.commit('updateequipment', {
        label: 'equipment',
        data: equipmentData
      });
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue